module.exports = __webpack_public_path__ + "static/media/151.81a79382.webp";